import Model from '@/common/models/common.model';
import { BackendTask as TaskSchema } from '@schema';
import type { TaskName } from '@/common/constants/taskNames.constants';

// "scheduled","running","success","failed","cancelling","cancelled","starting"

export default class Task extends Model {
  declare attributes: TaskSchema;

  get id(): ID {
    return this.attributes.task_id;
  }

  get data() {
    return this.attributes.data;
  }

  get pathVariables() {
    return this.attributes.args;
  }

  get payload() {
    return this.attributes.kwargs;
  }

  get event() {
    return this.attributes.event;
  }

  get result(): Record<string, any> {
    return this.attributes.result as Record<string, any>;
  }

  get state() {
    return this.attributes.state;
  }

  get name(): TaskName | string {
    return this.attributes.name;
  }

  get progress() {
    return this.attributes.progress;
  }

  get error() {
    return this.attributes.error;
  }

  get flow() {
    return this.attributes.flow;
  }
}
